<template>
  <div class="row">
      <div class="col-sm-12">
          <div class="card">
              <div class="card-body">
                  <div class="table-responsive table-desi table-product">
                      <v-data-table-server
                          class="table table-1d all-package"
                          v-model:items-per-page="itemsPerPage"
                          :search="search"
                          :headers="showHeaders"
                          :items-length="pagination.total"
                          :items="dataProductGrid"
                          :loading="loading"
                          item-value="name"
                          @update:options="getProductGrid"
                      >
                          <template v-slot:thead>
                              <tbody>
                                  <tr>
                                      <!-- <td v-if="selectedHeaders.includes('category')">
                                        <v-combobox
                                            label="Search category..."
                                            :items="dataCategoryCombo"
                                            item-title="name"
                                            item-value="id"
                                            v-model="category"
                                        ></v-combobox>
                                      </td> -->
                                      <td v-if="selectedHeaders.includes('name')">
                                          <v-text-field v-model="name" hide-details placeholder="Search name..." class="ma-2" density="compact"></v-text-field>
                                      </td>
                                     
                                      <td v-if="selectedHeaders.includes('description')">
                                          <v-text-field v-model="description" hide-details placeholder="Search description..." class="ma-2" density="compact"></v-text-field>
                                      </td>
                                      <td v-if="selectedHeaders.includes('sale_price')">
                                          <v-text-field v-model="sale_price" hide-details placeholder="Search sale price..." class="ma-2" density="compact"></v-text-field>
                                      </td>
                                      <td v-if="selectedHeaders.includes('discount')">
                                          <v-text-field v-model="discount" hide-details placeholder="Search discount..." class="ma-2" density="compact"></v-text-field>
                                      </td>
                                      <td v-if="selectedHeaders.includes('offer_price')">
                                          <v-text-field v-model="offer_price" hide-details placeholder="Search offer price..." class="ma-2" density="compact"></v-text-field>
                                      </td>
                                      <td v-if="selectedHeaders.includes('image')"></td>

                                      <td v-if="selectedHeaders.includes('active')"></td>

                                      <td v-if="selectedHeaders.includes('actions')"></td>
                                  </tr>
                              </tbody>
                          </template>
                          <template v-slot:item.name="{ item }">
                                <div class="product-name-cell">{{ item.name.es }}</div>
                            </template>
                            <template v-slot:item.description="{ item }">
                                <div class="product-description-cell">{{ formatDescription(item.description) }}</div>
                            </template>
                              <template v-slot:item.sale_price="{ item }">
                                  {{ formatCurrencyUsd(item.salePrice) }}
                              </template>
                              <template v-slot:item.offer_price="{ item }">
                                  {{ formatCurrencyUsd(item.offerPrice) }}
                              </template>

                          <template v-slot:item.image="{ item }">
                              <v-card class="my-2 v-responsive v-img rounded">
                                  <v-img v-if="getMainImage(item)"
                                        :src="getMainImage(item)"></v-img>
                              </v-card>
                          </template>
                          
                          <template v-slot:item.active="{ item }">
                              <v-checkbox class="ma-2"
                                  v-model="item.active"
                                  readonly
                              ></v-checkbox>
                          </template>
                          <template v-slot:item.actions="{ item }">
                              <v-btn color="primary" class="elevation-0" icon variant="plain" @click="editArticle(item)"> <v-icon> mdi-pencil-outline </v-icon> </v-btn>
                              <v-btn color="error" class="elevation-0" icon variant="plain" @click="openDeleteDialog(item)"><v-icon> mdi-trash-can-outline </v-icon> </v-btn>

                              <v-dialog v-model="dialogDelete" max-width="600px">
                                  <v-card>
                                      <v-card-title class="confirmation-dialog" primary-title>Confirmation</v-card-title>
                                      <v-card-text>
                                          Are you sure you want to delete the article with the name
                                          '{{ selectedItem ? getMultilangText(selectedItem.name) : "" }}'?
                                      </v-card-text>
                                      <v-card-actions>
                                          <v-btn color="red"   text @click="dialogDelete = false">Cancel</v-btn>
                                          <v-btn color="green" text :loading="deletingArticle" @click="deleteArticle(selectedItem)">Delete</v-btn>
                                      </v-card-actions>
                                  </v-card>
                              </v-dialog>
                          </template>
                      </v-data-table-server>
                      <v-alert v-if="messageError != ''" :type="typeOfMessage" :text="messageError"></v-alert>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { objectExpression } from '@babel/types'
import { getMultilangText } from '@/services/multilangText'
import { deleteArticleService } from '@/services/ArticleService'

export default {
    title: 'Products',
    props: {},
    data() {
        return {
            dataProductGrid: ref([]),
            pagination: ref({
                from: 0,
                to: 0,
                total: 0,
                current: 1,
                lastPage: 0
            }),
            itemsPerPage: 10,
            // FALTA - COMBO multi PARA LA CATEGORIA
            selectedHeaders: ['name', 'description', 'sale_price' ,'discount', 'offer_price','image', 'active','actions'],
            headers: [
                {
                    title: 'ID',
                    align: 'start',
                    sortable: true,
                    key: 'id'
                },
/*                 {
                    title: 'Category',
                    align: 'center',
                    sortable: true,
                    key: 'category'
                }, */
                {
                    title: 'Name',
                    align: 'center',
                    sortable: true,
                    key: 'name'
                },
                {
                    title: 'Description',
                    align: 'center',
                    sortable: true,
                    key: 'description'
                },
                {
                    title: 'Sale price (USD)',
                    align: 'center',
                    sortable: true,
                    key: 'sale_price',
                    value: 'salePrice'
                },
                {
                    title: 'Discount',
                    align: 'center',
                    sortable: true,
                    key: 'discount',
                    value: 'discount'
                },
                {
                    title: 'Offer price (USD)',
                    align: 'center',
                    sortable: true,
                    key: 'offer_price',
                    value: 'offerPrice'
                },
                {
                    title: 'Image',
                    align: 'center',
                    sortable: false,
                    key: 'image',
                    value: 'image'
                },
                {
                    title: 'Active',
                    align: 'center',
                    sortable: true,
                    key: 'active',
                    value: 'active'
                },
                {
                    title: 'Actions',
                    align: 'center',
                    sortable: false,
                    key: 'actions'
                }
            ],
            loading: true,

            // Filtros search
            search: '',
            id: '',
            category: '',
            name: '',
            description: '',
            sale_price: '',
            discount: '',
            offer_price: '',

            selectedItem: null,
            dialogDelete: false,
            deletingArticle: false,
            messageError: '',
            typeOfMessage: ''
        }
    },
    watch: {
        id() {
            this.search = String(Date.now())
        },
        name() {
            this.search = String(Date.now())
        },
        description() {
            this.search = String(Date.now())
        },
        sale_price() {
            this.search = String(Date.now())
        },
        discount() {
            this.search = String(Date.now())
        },
        offer_price() {
            this.search = String(Date.now())
        }
    },
    computed: {
        //Done to get the ordered headers
        showHeaders() {
            return this.headers.filter((s) => this.selectedHeaders.includes(s.key))
        }
    },
    methods: {
        getMultilangText,
        formatCurrencyUsd(value) {
            const numeric = Number(value)
            if (!Number.isFinite(numeric)) {
                return '0.00 USD'
            }

            return new Intl.NumberFormat('es-ES', {
                style: 'currency',
                currency: 'USD'
            }).format(numeric)
        },
        getMainImage(item) {
            if (!Array.isArray(item.multimedia)) {
                return ''
            }

            const images = item.multimedia.filter((media) => media && media.type === 'image' && media.path && media.name)
            if (images.length === 0) {
                return ''
            }

            const mainImage = images.find((media) => media.isMain) || images[0]

            return `${mainImage.path}${mainImage.name}`
        },
        formatDescription(value) {
            const rawText = getMultilangText(value)

            return String(rawText || '')
                .replace(/<[^>]*>/g, ' ')
                .replace(/&nbsp;/gi, ' ')
                .replace(/\s+/g, ' ')
                .trim()
          },
      getProductGrid({ page, itemsPerPage, sortBy, search }) {
            let self = this
            this.loading = true
           
            //Aplicamos los filtros
            let apiURL = process.env.VUE_APP_URL_API_BASE + '/article/grid-admin?page=' + page + '&limit=' + itemsPerPage + '&id=' + self.id 
            apiURL = apiURL + '&name=' + self.name
            apiURL = apiURL + '&description=' + self.description
            apiURL = apiURL + '&sale_price=' + self.sale_price
            apiURL = apiURL + '&offer_price=' + self.offer_price 
            apiURL = apiURL + '&discount=' + self.discount
            
            //Aplicamos el orden
            if (sortBy && sortBy[0]) {
                apiURL = apiURL + '&sort=' + sortBy[0].key + '&order=' + sortBy[0].order
            }

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {

                        // Obtenemos la data de dentro de blog guardandola en dataProductGrid
                        self.dataProductGrid = []
                        response.data.data.forEach(function (option) {
                            if (option) {
                                //Estos dos tienen multilenguaje
                               // option.content = option.content.es
                               // option.title = option.title.es
                                
                                self.dataProductGrid.push(option)
                            }
                        }) 

                        self.pagination.from = response.data.from
                        self.pagination.to = response.data.to
                        self.pagination.total = response.data.total
                        self.pagination.current = response.data.current_page
                        self.pagination.lastPage = response.data.last_page

                        
                        this.loading = false
                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        getListCategory() {
            let self = this

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/category/list'

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        self.dataCategoryCombo = []
                        response.data.forEach(function (option) {
                            if (option && option.categoryFather === null) {
                                self.dataCategoryCombo.push(option)
                            }
                        }) 


                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        editArticle(item) {
            this.$router.push({ path: "edit_product/" + item.id });
        },
        openDeleteDialog(item) {
            this.selectedItem = item
            this.dialogDelete = true
        },
        async deleteArticle(item) {
            if (!item || !item.id) {
                this.dialogDelete = false
                return
            }

            this.deletingArticle = true
            this.messageError = ''

            try {
                const response = await deleteArticleService(item.id)

                if (response?.data?.error) {
                    this.messageError = response.data.message || 'Error! El articulo no se ha eliminado.'
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response?.data?.message || 'Se ha eliminado correctamente.'
                    this.typeOfMessage = 'success'
                    this.search = String(Date.now())
                }
            } catch (error) {
                this.messageError = error?.response?.data?.message || 'Error! El articulo no se ha eliminado.'
                this.typeOfMessage = 'error'
            } finally {
                this.deletingArticle = false
                this.selectedItem = null
                setTimeout(() => (this.messageError = ''), 10000)
            }

            this.dialogDelete = false
        }
    },
   /*  created() {
        this.getListCategory()
    } */
}
</script>

<style scoped>
.product-name-cell,
.product-description-cell {
    display: -webkit-box;
    max-width: 320px;
    margin: 0 auto;
    overflow: hidden;
    text-align: left;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    -webkit-box-orient: vertical;
}

.product-name-cell {
    -webkit-line-clamp: 2;
    font-weight: 600;
}

.product-description-cell {
    -webkit-line-clamp: 3;
    color: #6c757d;
}
</style>

<style lang="scss" scoped>
.table-product {
    .v-data-table__td {
        span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 250px;
        }
    }
}
</style>
